import { Injectable } from '@angular/core';
import * as _ from 'lodash';

import { AppService } from 'app/app.service';
import { QueueStatusEnum } from 'app/enums';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InterviewService } from 'app/interview.service';
import { NotificationService, NotificationSeverity } from '@Services';
import { Input1DialogComponent } from '@Components/input1/input1-dialog.component';

@Injectable()
export class Input1IntegrationResponseHandler{
    dialogRef: MatDialogRef<Input1DialogComponent>;

    constructor(
        public appService: AppService,
        public interviewService: InterviewService,
        public notificationService: NotificationService,
        public dialog: MatDialog
    ) {}

    handleResponse(clientId: string, accountId: string,integrationResponse, integrationData){
        if (this.dialogRef && this.dialogRef != null) {
            this.dialogRef.close();
            return;
        }

        if (integrationResponse.status === QueueStatusEnum.Completed) {
            const link = _.get(integrationData, 'details.clientProperties.linkUrl');
            const error = _.get(integrationData, 'details.clientProperties.error');

            if (error && error !== null && error !== '') {
                this.notificationService.showNotification({severity: NotificationSeverity.Error, message: error, log: true });
                return;
            }

            this.showinput1EmbeddedDialog(clientId, accountId, integrationData.caseDetailId, integrationData.caseIntegrationQueueId, link);
        }
    }

    showinput1EmbeddedDialog(clientId: string, accountId: string, caseId: string, caseIntegrationQueueId: string, link) {
        this.dialogRef = this.dialog.open(Input1DialogComponent, {
            width: '800px',
            height: '90%',
            data: {
                clientId: clientId,
                caseId: caseId,
                caseIntegrationQueueId: caseIntegrationQueueId,
                link,
                accountId: accountId
            }
        });

        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
        });
    }
}
